import { Plus } from 'lucide-react';

export const FloatingActionButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="fab"
      aria-label="Neuen Schlaf-Eintrag hinzufügen"
    >
      <Plus className="w-6 h-6" />
    </button>
  );
}; 